<template>
  <bootstrap-modal v-if="show">
    <div
      slot="header"
      class="modal-header"
    >
      <button
        type="button"
        class="close modal__close-button"
        data-dismiss="modal"
        aria-label="Close"
        @click="$emit('modal-close')"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title">
        <contentful-text :item="contentfulText('checkout-download-photo-size-modal-title')" />
      </h4>
    </div>
    <div
      slot="body"
      class="modal-body"
    >
      <div class="photo-size-modal__lede">
        <contentful-text
          :item="contentfulText('checkout-download-photo-size-modal-lede')"
        />
      </div>

      <div>
        <div
          v-for="(photoSizeDetail, photoSizeDetailIndex) in photoSizeDetailsSorted"
          :key="photoSizeDetailIndex"
          :data-contentful-text="photoSizeDetail.Id"
          class="photo-size-detail"
        >
          <h3 class="photo-size-detail__name">
            {{ photoSizeDetail.Name }}
          </h3>
          <div class="photo-size-detail__description">
            {{ photoSizeDetail.Description }}
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-5">
              <contentful-text
                :item="contentfulText('checkout-download-photo-size-modal-dimensions-label')"
                :render-inline="true"
                class="photo-size-detail__label"
              />
              {{ photoSizeDetail.Dimensions }}
            </div>
            <div class="col-xs-12 col-sm-5">
              <contentful-text
                :item="contentfulText('checkout-download-photo-size-modal-file-size-label')"
                :render-inline="true"
                class="photo-size-detail__label"
              />
              {{ photoSizeDetail.FileSize }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-sm-offset-3">
          <button class="button photo-size-modal__close-button">
            <contentful-text :item="contentfulText('checkout-download-photo-size-modal-close-label')" />
          </button>
        </div>
      </div>
    </div>
  </bootstrap-modal>
</template>

<script>
import BootstrapModal from '@Shared/components/BootstrapModal'
import { sortBy } from 'lodash'

export default {
  name: 'PhotoSizeModal',
  components: {
    BootstrapModal
  },
  props: {
    show: { type: Boolean, default: false, required: true }
  },
  computed: {
    viewModel () {
      return this.$store.state.viewModel
    },
    content () {
      return this.viewModel.PageContent
    },
    photoSizeDetailsSorted () {
      return sortBy(this.viewModel.PhotoSizeDetailsContent, ['SortOrder'])
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-size-modal {
  &__lede {
    margin: 0 0 20px 0;
  }

  &__close-button {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    width: 100%;
  }
}

.photo-size-detail {
  margin: 0 0 20px 0;

  &__name {
    font-family: $font-open-sans;
    font-weight: bold;
    margin: 0 0 10px 0;
    padding: 0;
  }

  &__description {
    margin: 0 0 10px 0;
  }

  &__label {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/Photos/PhotoSizeModal.vue